<template>
    <div class="early-warn">
        <el-form :model="formData" ref="formRef" :rules="rules">
            <div class="form-head">{{t('trigger_condition')}}</div>
            <el-form-item prop="search_field" v-if="hasSovField">
                <el-input 
                    v-model="formData.search_field" 
                    :placeholder="t('search_field_placeholder')"
                />
            </el-form-item>
            <div class="clear-fix">
                <el-col :span="6">
                    <el-form-item prop="comparison_type">
                        <el-select v-model="formData.comparison_type">
                            <el-option 
                                v-for="item in comparisonTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="isEN?11: 7">
                    <el-form-item prop="comparison_value">
                        <el-input 
                            v-model="formData.comparison_value" 
                            class="pl10 pr10" 
                            :placeholder="t('comparison_value_placeholder')"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="isEN?7: 11">
                    <el-form-item prop="currency">
                         <el-select style="width:100%" clearable v-model="formData.currency" :placeholder="t('currency_placeholder')" >
                            <el-option 
                                v-for="item in currencyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </div>
            <!-- 统计时间范围 -->
            <div class="form-head">{{t('statistic_time_range')}}</div>
            <div class="clear-fix">
                <el-col :span="13">
                    <el-form-item prop="data_method">
                        {{t('last')}}
                        <!-- :style="{ width: isEN? '80px' : '120px'}" -->
                        <el-input 
                            v-model="formData.data_method" 
                            :style="{ width:  '120px'}"
                            :placeholder="t('data_method_placeholder')"
                        />
                        {{t('days')}}
                        <!-- 当天请输入1 -->
                        <span class="text-color-gray" :class="{font12px: isEN}">({{t('current_day_tip')}})</span>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item prop="time_zone">
                         <el-select 
                            style="width:100%" 
                            v-model="formData.time_zone" 
                            :placeholder="t('time_zone_placeholder')" 
                         >
                            <el-option 
                                v-for="item in timeZoneList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </div>
            <div class="form-head">{{t('check_frequency')}}</div>
            <el-form-item prop="check_frequency_time">
                <ESelect 
                    style="width:100%" 
                    v-model="formData.check_frequency_time" 
                    :placeholder="t('check_frequency_time_placeholder')" 
                    multiple
                    filterable
                    reserve-keyword
                    :filter-method="handleFilterMethod"
                >
                    <p class="option-select" v-if="filterTimeList.length">
                        <el-button type="text" @click="()=>handleCheckChange(true, filterTimeList)">{{t('select_all')}}</el-button>
                        <el-button type="text" @click="()=>handleCheckChange(false, filterTimeList)">{{t('deselect_all')}}</el-button>
                    </p>
                    <el-option 
                        v-for="item in filterTimeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </ESelect>
            </el-form-item>
            <div class="form-head">{{t('notification_recipient')}}</div>
            <el-form-item  :class="emailError?'is-error': ''" prop="notification_designated_email">
                <el-input 
                    :placeholder="t('email_placeholder')" v-model="input_email" 
                    @focus="emailError = ''"
                    @keyup.enter.native="()=>handleAddEmail()"
                >
                    <template slot="append"><div class="add_email" @click="()=>handleAddEmail()">{{t('add')}}</div></template>
                </el-input>
                <div class="el-form-item__error" v-if="emailError">{{emailError}}</div>
            </el-form-item>
            <el-form-item  v-if="formData.notification_designated_email.length">
                <el-tag
                    v-for="(email, index) in formData.notification_designated_email"
                    :key="email+index"
                    class="mb5"
                    closable
                    @close="handleEmailClose(index)"
                    type="info">
                    {{email}}
                </el-tag>
            </el-form-item>
             <div class="form-head">{{ t('trigger_action') }}</div>
             <el-checkbox-group v-model="formData.operation" class="mb10">
                <el-row >
                    <el-col :span="8" v-for="item in operationList" :key="item.value">
                         <el-checkbox 
                            :label="item.value"
                            class="mb8"
                        >
                            <span class="check-label">{{ item.label }}</span>
                        </el-checkbox>
                    </el-col>
                </el-row>
               
            </el-checkbox-group>

            <OperationForm 
                v-for="item in operationFormList" :key="item"
                v-bind="operationTypeParams[item]"
                :ref="`operation_${item}`"
                :defaultData="operationDefaultData[item] || {}"
                :t="t"
            />
        </el-form>
        <el-row type="flex" class="btns pt20 mt10" justify="space-between">
            <el-col >
                <!-- 去除监控 -->
                <el-button 
                    :disabled="loading" 
                    v-if="defaultData.id" 
                    :loading="removeLoading"
                    type="danger" 
                    plain
                    @click="handleRemoveData"
                >
                    {{t('remove_monitoring')}}
                </el-button>
            </el-col>
            <el-col class="tar">
                <!-- 关闭 -->
                <el-button :disabled="loading || removeLoading" type="primary" plain @click="handleClose"><span class="p10">{{t('off')}}</span></el-button>
                <!-- 保存 -->
                <el-button :loading="loading" :disabled="removeLoading" type="primary" @click="handleOnSubmit"><span class="p10">{{t('save')}}</span></el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { validEmail, validEmoji, validNum } from '@/utils/validate'
import OperationForm from './operationForm.vue'
const OPERATION_TYPE= {
    OFFER: '1', //出价
    DAILY_BUDGET: '6', //每日预算
    TOTAL_BUDGET: '7', //总预算
};
const OPERATION_LIST = Object.values(OPERATION_TYPE);
export default {
    props: [ 't', 'defaultData', 'hasSovField', 'cbs', 'isEN' ],
    components: { OperationForm },
    data() {
        const _this = this;
        const validateEmail = (rule, value, callback) => {
            
        };
        const validateSearchField = (rule, value, callback) => {
            if (!value) {
                callback(new Error(_this.t('search_field_valid_1')))
            }else {
                const test = /[\[\]\\;\{\}"<>]/;
                if (validEmoji(value) || test.test(value)) {
                    callback(new Error(_this.t('search_field_valid_2')))
                }else {
                    callback()
                }
            }
        };
        const validateComparisonValue = (rule, value, callback) => {
            if (!value || !validNum(value)) {
                callback(new Error(_this.t('comparison_value_valid_1')))
            }else {
                if (value.indexOf('.') > -1) {
                    const [ ,decimal ] = value.split('.');
                    if (decimal.length > 2) {
                        callback(new Error(_this.t('comparison_value_valid_1')));
                        return;
                    }
                };
                if (+value > 999999999.99) {
                    callback(new Error(_this.t('comparison_value_valid_2')));
                    return;
                }
                callback()
            }
        };
        const validateCurrency = (rule, value, callback)=> {
            if (value) {
                callback()
            }else {
                callback(new Error(_this.t('currency_valid_1')));
            }
        }
        const validateTimeZone = (rule, value, callback)=> {
            if (value) {
                callback()
            }else {
                callback(new Error(_this.t('time_zone_valid_1')));
            }
        }
        const validateCheckFrequencyTime = (rule, value, callback)=> {
            if (value&&value.length) {
                callback()
            }else {
                callback(new Error(_this.t('check_frequency_time_valid_1')));
            }
        }
        const validateNotificationDesignatedEmail = (rule, value, callback)=> {
            if (value&&value.length) {
                callback()
            }else {
                callback(new Error(_this.t('notification_designated_email_valid_1')));
            }
        }
        const validateDataMethod = (rule, value, callback) => {
            if (!value || !validNum(value) || +value > 93 || +value <=0 || value.indexOf('.') > -1) {
                callback(new Error(_this.t('data_method_valid_1')))
            }else {
               callback()
            }
        };
        const { operation, operationDefaultData } = JSON.parse(_this.defaultData.trigger_action || JSON.stringify({trigger_list: []})).trigger_list.reduce((pre, item)=> {
            if (OPERATION_LIST.includes(item.trigger_action)) {
                const { trigger_sub_action,trigger_action_detail,trigger_action_value } = item;
                pre.operationDefaultData[item.trigger_action] = {
                    operationType: trigger_sub_action,
                    adjustmentType: trigger_action_detail,
                    amountOfMoney: trigger_action_value
                }
            }
            pre.operation.push(item.trigger_action);
            return pre;
        }, { operation: [], operationDefaultData: {} })
        const formData = Object.assign({ 
            comparison_type: '1',
            comparison_value: '',
            currency: '',
            data_method: '',//最近多少天
            time_zone: '',//时区
            check_frequency_time: [], //检查频次
            notification_designated_email: [],//通知人邮箱
            search_field: '',//搜索关键词
            operation: [],//触发操作
        }, {
            ..._this.defaultData,
            operation
        });
        return {
            operationDefaultData,
            emailError: '',
            input_email: '',
            frequencyKeyWord: '',
            cacheFormData: JSON.stringify(formData),
            formData,
            comparisonTypeList:[//触发条件
                { value: '1', label: _this.t('greater_than_or_equal_to') },
                { value: '2', label: _this.t('less_than_or_equal_to') },
            ],
            currencyList:[//账户属性
                { value: '1', label: _this.t('rmb')  },
                { value: '2', label: _this.t('usd') },
            ],
            timeZoneList: [
                { value: 'Asia/Shanghai', label: _this.t('shanghai')  },
                { value: 'UTC', label: 'UTC'  },
            ],
            rules: {
                search_field: [
                    { validator: validateSearchField, trigger: 'blur' }
                ],
                comparison_value: [
                    { validator: validateComparisonValue, trigger: 'change' }
                ],
                currency: [
                    { validator: validateCurrency, trigger: 'blur' }
                ],
                data_method: [
                    { validator: validateDataMethod, trigger: 'change' }
                ],
                time_zone: [
                    { validator: validateTimeZone, trigger: 'blur' }
                ],
                check_frequency_time: [
                    { validator: validateCheckFrequencyTime, trigger: 'blur' }
                ],
                notification_designated_email: [
                    { validator: validateNotificationDesignatedEmail, trigger: 'none' }
                ]
            },
            loading: false,
            removeLoading: false,
            operationList: [
                { value: OPERATION_TYPE.OFFER, label: _this.t('adjust_bid') },
                { value: '2', label: _this.t('closed_status') },
                { value: '3', label: _this.t('convert_keywords') },
                { value: '4', label: _this.t('convert_nokeywords') },
                { value: '5', label: _this.t('del_keywords') },
                { value: OPERATION_TYPE.DAILY_BUDGET, label: _this.t('daily_budget') },
                { value: OPERATION_TYPE.TOTAL_BUDGET, label: _this.t('total_budget')},
            ],
            operationTypeParams: {
                [OPERATION_TYPE.OFFER]: {
                    title: _this.t('adjust_bid'),
                    list: [
                        { value: '1', label: _this.t('new_bid'), type: 'add' },
                        { value: '2', label: _this.t('increase_bid'), type: 'update' },
                        { value: '3', label: _this.t('decrease_bid'), type: 'update' },
                    ]
                },
                [OPERATION_TYPE.DAILY_BUDGET]: {
                    title: _this.t('daily_budget'),
                    list: [
                        { value: '1', label: _this.t('new_budget'), type: 'add' },
                        { value: '2', label: _this.t('increase_budget'), type: 'update' },
                        { value: '3', label: _this.t('decrease_budget'), type: 'update' },
                    ]
                },
                [OPERATION_TYPE.TOTAL_BUDGET]: {
                     title: _this.t('total_budget'),
                    list: [
                        { value: '1', label: _this.t('new_budget'), type: 'add' },
                        { value: '2', label: _this.t('increase_budget'), type: 'update' },
                        { value: '3', label: _this.t('decrease_budget'), type: 'update' },
                    ]
                }
            }
        }
    },
    computed: {
        filterTimeList() {
            const list =  Array.from({length: 24}).map((_, i)=> {
                const t = `${i}`.padStart(2, '0');
                const time = `${t}:00`
                return { value: time, label: time  };
            });
            return list.filter(time=> {
                return time.label.indexOf(this.frequencyKeyWord) > -1
            })
        },
        operationFormList() {
            return OPERATION_LIST.filter(key=> {
                return this.formData.operation.includes(key)
            })
        }
        // operationListGroup() {
        //     const groupNum = 3;
        //     return this.operationList.reduce((pre, item)=> {
        //         const lastData = pre[pre.length];
        //         if (lastData && lastData.length < groupNum) {
        //             lastData.push(item)
        //         }else {
        //             pre.push([item])
        //         }
        //         return pre
        //     }, [])
        // }
        
    },
    
    methods: {
        handleEmailClose(index) {
            this.formData.notification_designated_email.splice(index, 1)
        },
        async handleAddEmail() {
            this.$refs['formRef'].clearValidate()
            const value = this.input_email;
            const list = [...new Set((value || '').split(/,|，/))].filter(email=> {
                return !this.formData.notification_designated_email.includes(email)
            });
            if (!value || !list.every(v=>validEmail(v))) {
                this.emailError = this.t('email_valid_2')
            }else {
                if (list.length + this.formData.notification_designated_email.length > 20) {
                    this.emailError = this.t('email_valid_3')
                }else {
                    this.input_email = ''
                   this.formData.notification_designated_email = [...this.formData.notification_designated_email, ...list ] ;
                }
            }
        },
        handleFilterMethod(KeyWord) {
            this.frequencyKeyWord = KeyWord;
        },
        handleCheckChange(check, data) {
			if (!Array.isArray(data)) {
				data = [ data ];
			};
            const checkIds = this.formData.check_frequency_time;
			if (check) {
				const filterList = data.filter(v=>!checkIds.includes(v.value)).map(v=>v.value);
				this.formData.check_frequency_time = [].concat(filterList, checkIds);
			}else {
				const ids = data.map(v=>v.value);
				this.formData.check_frequency_time = this.formData.check_frequency_time.filter(v=>!ids.includes(v))
			}
		},
        async handleRemoveData() {
            try {
                this.removeLoading = true;
                await this.cbs.removeData(this.formData.id)
            }catch(error){
                this.$message.error(error.info || error.message)
                console.log(error, '智能预警删除错误');
            } finally {
                this.removeLoading = true;
            }
        },
        async handleOnSubmit() {
            const valid = await this.$refs['formRef'].validate();
            if (!valid) {
                return;
            };
            const operationParams = await Promise.all(
                Object.keys(this.operationTypeParams).map(key=>{
                    const [ ref ] = this.$refs[`operation_${key}`] || [];
                    return [ ref, key ];
                }).filter(v=>!!v[0]).map(([ ref, key ])=> {
                    return ref.getFormData().then(data=> {
                        return { trigger_action: key, ...data }
                    })
                })
            );
            try {
                this.loading = true;
                const { 
                    comparison_type, comparison_value, currency, data_method, 
                    time_zone, check_frequency_time, notification_designated_email,
                    search_field, id, operation
                } = this.formData;
                const params = {
                    comparison_type, comparison_value,currency,
                    data_method,time_zone,
                    check_frequency_time: check_frequency_time.toString(),
                    notification_designated_email: notification_designated_email.toString(),
                    trigger_action: JSON.stringify({ 
                        trigger_list: [].concat(operation.filter(key=>!this.operationTypeParams[key]).map(key=> {
                            return {
                                trigger_action: key,
                                trigger_sub_action: '',
                                trigger_action_detail: '',
                                trigger_action_value: ''
                            }
                        }), operationParams)
                    })
                };
                if (this.hasSovField) {
                    params.search_field = search_field;
                };
                if (id) {
                    params.id = id;
                }
                await this.cbs.onSubmit(params)
            }catch(error){
                this.$message.error(error.info || error.message)
                console.log(error, '智能预警提交错误');
            } finally {
                this.loading = false;
            }
        },
        handleClose() {
            if (this.cacheFormData === JSON.stringify(this.formData)) {
                this.$emit('close')
            }else {
                const t = this.t;
                this.$confirm(t('off_message'), t('off_prompt'), {
                    confirmButtonText: t('off_confirm'),
                    cancelButtonText: t('off_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.$emit('close')
                }).catch(() => {});
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.early-warn {
    &::v-deep {
        .el-input-group__append {
            background: #409eff;
            border: 1px solid #409eff;
            padding: 0;
            text-align: center;
        }
    }
}
.form-head {
    padding-left: 20px;
    font-size: 14px;
    background: #e8f0f9;
    color: #409eff;
    font-weight: bold;
    border-radius: 4px;
    position: relative;
    margin-bottom: 14px;
    &::before {
        position: absolute;
        content: '';
        left: 6px;
        height: 80%;
        width: 4px;
        background: #409eff;
        border-radius: 2px;
        top: 50%;
        transform: translateY(-50%);
    }
}
.check-label {
    // display: inline-block;
    word-wrap: break-word;
    white-space:normal;
}
.add_email {
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
}
.btns {
    border-top: 1px solid #ccc;
}
</style>